import {CookieOptions, CookieService} from "ngx-cookie";
import {Injectable} from "@angular/core";
import {CookieConstantes} from "../constantes/cookie.constantes";

@Injectable()
export class CerbaCookieService {

    COOKIE_LENGTH: number = 3900;

    constructor(private cookieService: CookieService) {
    }

    getCoockieValue(key: string): string {
        let value: string = null;
        const cookies: {} = this.cookieService.getAll();
        if (cookies != null) {
            let cookieKeys: string[] = Object.keys(cookies);
            cookieKeys.forEach((cookieKey: string) => {
                if (cookieKey.startsWith(key)) {
                    let cookieValue = this.cookieService.get(cookieKey);
                    if (cookieValue != null) {
                        if (value == null) {
                            value = cookieValue;
                        } else {
                            value = value.concat(cookieValue);
                        }
                    }
                }
            });
        }
        return value;
    }

    addCoockie(key: string, value: string): void {
        let options: CookieOptions = {};
        let serverName = this.getDomain(window.location.hostname);
        options.domain = serverName;
        options.path = "/";

        if (CookieConstantes.COOKIE_CORRESPONDANT === key) {
            if (value.length > this.COOKIE_LENGTH) {
                let cookieCount: number = Math.ceil(value.length / this.COOKIE_LENGTH);
                for (let i: number = 0; i < cookieCount; i++) {
                    let cookieValue: string = value.substr(i * this.COOKIE_LENGTH, Math.min(this.COOKIE_LENGTH, value.length - i * this.COOKIE_LENGTH));
                    this.cookieService.put(key + "_" + i, cookieValue, options);
                }
            } else {
                this.cookieService.put(key + "_0", value, options);
            }
        }else{
            this.cookieService.put(key, value, options);
        }
    }

    removeCoockie(key: string): void {
        let cookies: {} = this.cookieService.getAll();
        if (cookies != null) {
            let cookieKeys: string[] = Object.keys(cookies);
            cookieKeys.forEach((cookieKey: string) => {
                if (cookieKey.startsWith(key)) {
                    let options: CookieOptions = {};
                    let serverName = this.getDomain(window.location.hostname);
                    options.domain = serverName;
                    options.path = "/";
                    this.cookieService.remove(cookieKey, options);
                }
            });
        }
    }

    getDomain(sN: string): string {
        let serverName = sN;
        let serverPaths = serverName.split('.');
        let parts = serverPaths.length;
        if (parts > 1) {
            serverName = serverPaths[parts - 2] + "." + serverPaths[parts - 1];
        }
        return serverName;
    }

    /**
     * Retourne l'URL de base du module support en fonction du hostname courant.
     * Doit rester aligne sur header-common.js (template-serveur) et sur les filtres maven
     * (support.base.url dans CERBA_SiteCentral).
     * ATTENTION : .npe.mycerba.com doit etre teste avant .mycerba.com (qui matcherait sinon a tort).
     */
    getSupportBaseUrl(hostname: string): string {
        let protocol = window.location.protocol;
        // DEV utilisateur : anciens modules sur .mycerba-it.com et nouveaux modules sur *-mycerbaint.digital.bluesoft-group.com
        if (hostname.indexOf('mycerbaint.digital.bluesoft-group.com') !== -1 || hostname.indexOf('.mycerba-it.com') !== -1) {
            return protocol + '//support-mycerbaint.digital.bluesoft-group.com';
        }
        // STAGING utilisateur : nouveaux modules sur .npe.mycerba.com et anciens modules sur .mycerba-pp.com
        if (hostname.indexOf('.npe.mycerba.com') !== -1 || hostname.indexOf('.mycerba-pp.com') !== -1) {
            return protocol + '//support.npe.mycerba.com';
        }
        // PRODUCTION
        if (hostname.indexOf('.mycerba.com') !== -1) {
            return protocol + '//support.mycerba.com';
        }
        // fallback (local ou env non identifie)
        return protocol + '//www.' + this.getDomain(hostname);
    }

    removeAll(): void {
        this.cookieService.removeAll();
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/services/cerbacookie.service.ts